var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "go-modal-detail modal fade",
        { show: _vm.isShowDetailReport, "d-block": _vm.isShowDetailReport },
      ],
      staticStyle: { "overflow-y": "auto" },
      attrs: { id: "go-detail-report" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _vm.loading
              ? _c(
                  "div",
                  { staticClass: "go-detail-container" },
                  [
                    _c("div", { staticClass: "go-detail-toolbar" }, [
                      _c("div", { staticClass: "go-fixed-box" }, [
                        _c("div", { staticClass: "go-btn-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-icon",
                              attrs: {
                                id: "buttonCloseReportDetail",
                                type: "button",
                                "data-dismiss": "modal",
                                disabled: _vm.updatingBookmark,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleClickClosePopup.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: {
                                        placement: "topright",
                                        customClass: "go-tooltip",
                                      },
                                      expression:
                                        "{ placement: 'topright', customClass: 'go-tooltip' }",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  staticClass: "go-tooltip-area",
                                  attrs: { title: _vm.$t("report.close") },
                                },
                                [
                                  _c("i", {
                                    staticClass: "go-icon-24 go-icon-close",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-btn-group" }, [
                          this.getSelectedResource.originParentDocDetail &&
                          !this.getSelectedResource.isGroupChildren &&
                          !_vm.displayPolarisEdit
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  class: [
                                    {
                                      active:
                                        this.getSelectedResource.isBookmarked,
                                    },
                                  ],
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "button",
                                    disabled:
                                      _vm.updatingBookmark ||
                                      _vm.displayPolarisEdit ||
                                      _vm.openPolaris,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.addToResource.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass:
                                        "go-tooltip-area go-toggle-off",
                                      attrs: {
                                        title: _vm.$t(
                                          "briefing.label.add-to-scrape"
                                        ),
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-bookmark",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass:
                                        "go-tooltip-area go-toggle-on",
                                      attrs: {
                                        title: _vm.$t(
                                          "briefing.label.remove-to-scrape"
                                        ),
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-bookmark-on",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkToShow(
                            "hideButton",
                            this.getSelectedResource
                          ) && !_vm.displayPolarisEdit
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: {
                                    type: "button",
                                    disabled:
                                      _vm.updatingBookmark ||
                                      _vm.displayPolarisEdit ||
                                      _vm.openPolaris,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.callHideFunction.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.userKey ===
                                  this.getSelectedResource.owner_user_key
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                placement: "topright",
                                                customClass: "go-tooltip",
                                              },
                                              expression:
                                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass: "go-tooltip-area",
                                          attrs: {
                                            title: _vm.$t(
                                              "common.label.delete"
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-24 go-icon-trash",
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                placement: "topright",
                                                customClass: "go-tooltip",
                                              },
                                              expression:
                                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass: "go-tooltip-area",
                                          attrs: {
                                            title: _vm.$t(
                                              "common.label.hidden"
                                            ),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-24 go-icon-hidden",
                                          }),
                                        ]
                                      ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.displayPolarisEdit
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: {
                                    disabled:
                                      _vm.updatingBookmark ||
                                      _vm.displayPolarisEdit ||
                                      _vm.openPolaris,
                                    type: "button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.shareReport.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: { title: _vm.$t("report.share") },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "go-icon-24 go-icon-share",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.displayPolarisEdit && !_vm.isEdited
                            ? _c(
                                "div",
                                {
                                  key: _vm.downloadAt,
                                  staticClass: "go-dropdown-group dropdown",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn go-btn-icon dropdown-toggle",
                                      attrs: {
                                        disabled: _vm.updatingBookmark,
                                        type: "button",
                                        "data-toggle": "dropdown",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                placement: "topright",
                                                customClass: "go-tooltip",
                                              },
                                              expression:
                                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass: "go-tooltip-area",
                                          attrs: {
                                            title: _vm.$t("report.download"),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-24 go-icon-download",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-menu",
                                      staticStyle: { "margin-left": "-45px" },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            disabled: _vm.updatingBookmark,
                                            type: "button",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.downloadReportPDF.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._m(0),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "go-text",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t("report.downloadPDF")
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.isGuest
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                disabled: _vm.updatingBookmark,
                                                type: "button",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.downloadAsWord.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._m(1),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "go-text",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "report.downloadWord"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.displayPolarisView && _vm.isEdited
                            ? _c(
                                "div",
                                { staticClass: "go-dropdown-group dropdown" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn go-btn-icon dropdown-toggle",
                                      attrs: {
                                        disabled:
                                          _vm.updatingBookmark ||
                                          _vm.openPolaris,
                                        type: "button",
                                        "data-toggle": "dropdown",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                placement: "topright",
                                                customClass: "go-tooltip",
                                              },
                                              expression:
                                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass: "go-tooltip-area",
                                          attrs: {
                                            title: _vm.$t("report.download"),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-24 go-icon-download",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-menu",
                                      staticStyle: { "margin-left": "-45px" },
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.downLoadPDFFromPolaris.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._m(2),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "go-text",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t("report.downloadPDF")
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.downloadWordFromPolaris.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._m(3),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "go-text",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t("report.downloadWord")
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isEdited && !_vm.displayPolarisEdit
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: {
                                    disabled:
                                      _vm.updatingBookmark ||
                                      _vm.displayPolarisEdit,
                                    type: "button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.printReports.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: { title: _vm.$t("report.print") },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "go-icon-24 go-icon-print",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.displayPolarisView && _vm.isEdited
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: {
                                    disabled:
                                      _vm.updatingBookmark ||
                                      _vm.displayPolarisEdit ||
                                      _vm.openPolaris,
                                    type: "button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.print.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: { title: _vm.$t("report.print") },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "go-icon-24 go-icon-print",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.userLogin === _vm.items.owner_user_key
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: {
                                    id: "edit",
                                    type: "button",
                                    disabled:
                                      _vm.openPolaris || _vm.updatingBookmark,
                                  },
                                  on: { click: _vm.togglePolarisEdit },
                                },
                                [
                                  _vm.displayPolarisEdit === false
                                    ? _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                placement: "topright",
                                                customClass: "go-tooltip",
                                              },
                                              expression:
                                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass: "go-tooltip-area",
                                          attrs: {
                                            title: _vm.$t("report.edit"),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-24 go-icon-edit",
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                placement: "topright",
                                                customClass: "go-tooltip",
                                              },
                                              expression:
                                                "{ placement: 'topright', customClass: 'go-tooltip' }",
                                              modifiers: { hover: true },
                                            },
                                          ],
                                          staticClass: "go-tooltip-area",
                                          attrs: {
                                            title: _vm.$t("report.view"),
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-24 go-icon-view",
                                          }),
                                        ]
                                      ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn go-btn-icon",
                              attrs: {
                                id: "view",
                                type: "button",
                                hidden: !_vm.displayPolarisEdit,
                                disabled: _vm.openPolaris,
                              },
                              on: { click: _vm.saveDocument },
                            },
                            [_vm._m(4)]
                          ),
                        ]),
                        _vm._v(" "),
                        !_vm.displayPolarisEdit
                          ? _c("div", { staticClass: "go-btn-group" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.updatingBookmark,
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.addToNewAgentBriefing.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          value: {
                                            placement: "topright",
                                            customClass: "go-tooltip",
                                          },
                                          expression:
                                            "{ placement: 'topright', customClass: 'go-tooltip' }",
                                          modifiers: { hover: true },
                                        },
                                      ],
                                      staticClass: "go-tooltip-area",
                                      attrs: { title: _vm.$t("report.goover") },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-24 go-icon-goover",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.displayPolarisView || _vm.displayPolarisEdit
                      ? _c(
                          "div",
                          { staticClass: "go-detail-content" },
                          [
                            _c(
                              "div",
                              {
                                ref: "polarisArea",
                                staticClass:
                                  "go-report-template-01 go-detail-report",
                                staticStyle: { height: "100%" },
                                attrs: { id: "polaris-area" },
                              },
                              [
                                _vm.displayPolarisEdit
                                  ? _c("div", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        position: "absolute",
                                      },
                                      attrs: { id: "weboffice_container" },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            !_vm.displayPolarisEdit && _vm.getSelectedResource
                              ? _c("report-comment", {
                                  attrs: { data: _vm.getSelectedResource },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("report-content", {
                      ref: "reportContent",
                      attrs: {
                        loading: _vm.loading,
                        dataHeading: _vm.dataHeading,
                        dataBody: _vm.dataBody,
                        dataTableOfContent: _vm.dataTableOfContent,
                        dataReference: _vm.dataReference,
                        logo: _vm.logo,
                        selectedComponent: _vm.selectedComponent,
                        articleRelatedPeople: _vm.articleRelatedPeople,
                        articleRelatedDocument: _vm.articleRelatedDocument,
                        headingSelected: _vm.headingSelected,
                        detailReport: true,
                        reportType: _vm.reportType,
                        viewCount: _vm.items.countView,
                        displayPolarisEdit: _vm.displayPolarisEdit,
                        displayPolarisView: _vm.displayPolarisView,
                        isEdited: _vm.isEdited,
                        ownerUserKey: _vm.items.owner_user_key,
                      },
                      on: {
                        selectBody: _vm.selectBody,
                        selectComponent: _vm.selectComponent,
                        file: _vm.getFileDoc,
                      },
                    }),
                    _vm._v(" "),
                    !_vm.displayPolarisEdit
                      ? _c("div", { staticClass: "go-detail-aside" }, [
                          _c("div", { staticClass: "go-fixed-box" }, [
                            _c(
                              "div",
                              { staticClass: "go-panel go-panel-aside" },
                              [
                                _c("div", { staticClass: "go-panel-header" }, [
                                  _c("ul", { staticClass: "nav go-tab-line" }, [
                                    _c(
                                      "li",
                                      {
                                        staticClass: "go-tab-item",
                                        on: {
                                          click: function ($event) {
                                            _vm.isShowReportRef = false
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            class: [
                                              "go-tab-link",
                                              { active: !_vm.isShowReportRef },
                                            ],
                                            attrs: {
                                              "data-toggle": "tab",
                                              "data-target": "#home",
                                              role: "tab",
                                              "aria-selected": "true",
                                            },
                                          },
                                          [_vm._v("Ask Goover")]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "go-tab-item",
                                        on: {
                                          click: function ($event) {
                                            _vm.isShowReportRef = true
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            class: [
                                              "go-tab-link",
                                              { active: _vm.isShowReportRef },
                                            ],
                                            attrs: {
                                              "data-toggle": "tab",
                                              "data-target": "#profile",
                                              role: "tab",
                                              "aria-selected": "false",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("report.reportReference")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "go-panel-body tab-content" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "tab-pane fade",
                                          _vm.isShowReportRef
                                            ? ""
                                            : "show active",
                                        ],
                                        attrs: { id: "home" },
                                      },
                                      [
                                        _c("ask-sub", {
                                          ref: "askGoover",
                                          attrs: {
                                            "reference-documents": [
                                              _vm.getSelectedResource.docId,
                                            ].concat(_vm.contentReference),
                                            "full-size": false,
                                            page: _vm.PAGES.REPORT_DETAIL,
                                            docId:
                                              _vm.getSelectedResource.docId,
                                            targetBpId: _vm.conversationId,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "tab-pane fade",
                                          _vm.isShowReportRef
                                            ? "show active"
                                            : "",
                                        ],
                                        attrs: { id: "profile" },
                                      },
                                      [
                                        _c("reportReferent", {
                                          attrs: {
                                            items: _vm.contentReference,
                                            "related-reference":
                                              _vm.allRelatedReference,
                                            headingSelected:
                                              _vm.headingSelected,
                                            "show-edit-reference":
                                              _vm.isMyReport,
                                          },
                                          on: {
                                            headingSelected:
                                              _vm.handleHeadingSelected,
                                            items: _vm.handleContentReference,
                                            clearSelected:
                                              _vm.handleClearSelected,
                                            handleIsEditedReferenceDocuments:
                                              _vm.handleIsEditedReferenceDocuments,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "go-icon-20" }, [
      _c("img", {
        attrs: {
          src: "content/images/images_v3/common/go-icon-document/file-pdf-fill.svg",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "go-icon-20" }, [
      _c("img", {
        attrs: {
          src: "content/images/images_v3/common/go-icon-document/file-word-fill.svg",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "go-icon-20" }, [
      _c("img", {
        attrs: {
          src: "content/images/images_v3/common/go-icon-document/file-pdf-fill.svg",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", { staticClass: "go-icon-20" }, [
      _c("img", {
        attrs: {
          src: "content/images/images_v3/common/go-icon-document/file-word-fill.svg",
        },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "go-tooltip go-tooltip-left",
        attrs: { "data-toggle": "tooltip", title: "Save" },
      },
      [_c("i", { staticClass: "go-icon-24 go-icon-file-check" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }